import React from 'react';
import ContactComponent from '../components/Contact/Contact';

/**
 * ContactPage - Contact page wrapper
 */
export default function ContactPage() {
  return <ContactComponent />;
}
